import { Component, Input, OnInit } from '@angular/core';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-revision-notices-abstract-section',
  templateUrl: './revision-notices-abstract-section.component.html',
  styleUrls: ['./revision-notices-abstract-section.component.scss']
})
export class RevisionNoticesAbstractSectionComponent implements OnInit {
  @Input() sections: Section[] = [];
  constructor() {}

  ngOnInit(): void {}
}
